import React from 'react';

function SqlKeyword({ children }) {
  return (
    <span style={{ color: '#007bff' }}>{children}</span>
  );
}

export default SqlKeyword;